import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Panel, PanelTitle } from '@prisjakt/ui/panel';
import { AppContext } from 'src/components/app-context';
import { BodySmallText, H4Text } from '@prisjakt/ui/text/variants';
import CampaignLink from '../link';
import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const CampaignGroup = ({ campaigns, title, className }) => {
  const { t } = useContext(AppContext);
  return (
    <Panel className={className}>
      {title && <PanelTitle>{title}</PanelTitle>}
      <S.RowWithWrap>
        {campaigns.map(campaign => (
          <S.CampaignListItem key={campaign.id}>
            <H4Text>{campaign.title.short}</H4Text>
            <BodySmallText container="p">
              {campaign.description.short}
            </BodySmallText>
            <CampaignLink
              campaign={campaign}
              linkContent={t('campaigns', 'link.visit-campaign')}
              onClick={() =>
                trackInternalNavigationClick({
                  scope: InternalNavigationScope.CAMPAIGN_GO_TO,
                  nextPage: campaign.web_uri.responsive,
                })
              }
            />
          </S.CampaignListItem>
        ))}
      </S.RowWithWrap>
    </Panel>
  );
};

const { arrayOf, number, shape, string } = PropTypes;

CampaignGroup.propTypes = {
  title: string,
  campaigns: arrayOf(
    shape({
      id: number.isRequired,
      slug: string,
      title: shape({
        short: string,
        long: string,
      }),
      description: shape({
        short: string,
        long: string,
      }),
    }).isRequired
  ).isRequired,
  className: string,
};

CampaignGroup.defaultProps = {
  title: undefined,
  className: undefined,
};

export default CampaignGroup;
